import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { InvoiceItem } from '../types';
import { StyledCard, CardTitle } from '../cardStyles';
import { AvisoTotais, InfoRow, TotalLinha, TotalValor, ComposicaoToggle, Composicao } from '../style';

interface Props {
  items: InvoiceItem[];
  frete: number;
}

const parseBrl = (val: unknown): number => {
  if (typeof val === 'number') return val;
  return Number(String(val || 0).replace(/\./g, '').replace(',', '.') || 0);
};

const formatBrl = (val: number) =>
  val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const TotaisSection: React.FC<Props> = ({ items, frete }) => {
  const totalProdutos = items.reduce((sum, item) => sum + parseBrl(item.vlTotal), 0);
  const totalIcms = items.reduce((sum, item) => sum + parseBrl(item.vlIcms), 0);
  const totalIpi = items.reduce((sum, item) => sum + parseBrl(item.vlIpi), 0);
  const totalNfe = totalProdutos + totalIpi + frete;
  const itensSemRegraIpi = items.filter((item) => item.origemIpi === 'SEM_REGRA').length;
  const [composicaoAberta, setComposicaoAberta] = useState(true);

  return (
    <StyledCard>
      <CardTitle>Totais</CardTitle>
      <TotalLinha>
        <span>Total NF-e</span>
        <TotalValor>
          <strong>{formatBrl(totalNfe)}</strong>
          <ComposicaoToggle
            type="button"
            aria-expanded={composicaoAberta}
            aria-label={composicaoAberta ? 'Recolher composição' : 'Abrir composição'}
            title={composicaoAberta ? 'Recolher composição' : 'Abrir composição'}
            onClick={() => setComposicaoAberta((aberta) => !aberta)}
          >
            <ChevronDown size={14} />
          </ComposicaoToggle>
        </TotalValor>
      </TotalLinha>
      {composicaoAberta && (
        <Composicao>
          <InfoRow><span>Produtos</span><span>{formatBrl(totalProdutos)}</span></InfoRow>
          <InfoRow><span>IPI</span><span>{formatBrl(totalIpi)}</span></InfoRow>
          {frete > 0 && <InfoRow><span>Frete</span><span>{formatBrl(frete)}</span></InfoRow>}
          <InfoRow><span>ICMS (já no preço)</span><span>{formatBrl(totalIcms)}</span></InfoRow>
        </Composicao>
      )}
      {itensSemRegraIpi > 0 && (
        <AvisoTotais>
          {itensSemRegraIpi} {itensSemRegraIpi === 1 ? 'item' : 'itens'} sem regra de IPI; a emissão vai barrar.
        </AvisoTotais>
      )}
    </StyledCard>
  );
};

export default TotaisSection;
